/**
 * Billing setup: tier choice + pricing. Shared; white-glove mode shows setup fee + monthly.
 * Plan: billing_infrastructure_plan §1.8.
 */
import {
  whiteGloveSetupFee,
  whiteGloveMonthlyAlert,
  whiteGloveVolumeDiscountPct,
} from '@/lib/white-glove';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export interface BillingSetupProps {
  /** White-glove mode: use estimated system count and show setup fee. */
  whiteGloveMode?: boolean;
  /** Estimated or actual system count. */
  systemCount: number;
}

export default function BillingSetup({ whiteGloveMode = false, systemCount }: BillingSetupProps) {
  const setupFee = whiteGloveMode ? whiteGloveSetupFee(systemCount) : 0;
  const monthly = whiteGloveMonthlyAlert(systemCount);
  const discountPct = whiteGloveVolumeDiscountPct(systemCount);

  return (
    <Card className="max-w-md mx-auto" data-testid="billing-setup">
      <CardHeader>
        <CardTitle>Billing</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {whiteGloveMode && setupFee > 0 && (
          <p data-testid="setup-fee-display">
            Setup fee: ${setupFee} one-time
          </p>
        )}
        <p data-testid="monthly-display">
          Monthly: ${monthly}
          {discountPct > 0 && (
            <span data-testid="volume-discount-note">
              {' '}({discountPct}% off at next invoice)
            </span>
          )}
        </p>
      </CardContent>
    </Card>
  );
}
